export class AssessmentReportInfo {
    constructor() {
        this.type = null;
        this.reason = null;
        this.commentDto = null;
        this.isViolation = true;
        this.addProctoringImagesToReport = false;
    }
}
//# sourceMappingURL=assessmentReportInfo.js.map